import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";
import { reduxActions as RESOURCE } from "_constants/resource.constants";
import initialResourceState from "../resource.initialState";

const one = {
  [RESOURCE.ONE_STARTED]: (state) => ({
    ...state,
    one: {
      ...state.one,
      status: LOADING
    }
  }),
  [RESOURCE.ONE_FAIL]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),
  [RESOURCE.ONE_SUCCESS]: (state, { payload }) => ({
    ...state,
    one: {
      ...state.one,
      data: payload?.data?.[0] ?? null,
      status: SUCCESS
    }
  }),
  [RESOURCE.ONE_RESET]: (state) => ({
    ...state,
    one: initialResourceState.one
  })
};

export default one;
